import React from "react";
import { useParams } from "react-router-dom";

const Company = () => {
  const { id } = useParams();

  return <div>Company {id}</div>;
};

export default Company;
